import { TaggedError } from "@for-it/domain-lib";
export class TagAlreadyExistsError extends TaggedError {
    constructor() {
        super("TagAlreadyExistsError");
    }
}
